<template>
  <div>
    <div class="new-btn-wrap">
      <auth-button code="HTJHXZ" icon="el-icon-plus" size="mini" type="primary" @click="newReceiptPlan">新建回款计划</auth-button>
    </div>
    <div class="list-table">
      <new-table ref="planTableRef" :data="tableData" :columns="columns" :pages="pages"></new-table>
    </div>
    <!-- 新建回款计划 弹窗 -->
    <el-dialog :visible.sync="visible" :title="`${formData.id ? '修改' : '新建'}回款计划`" width="800px" @close="closeDialog">
      <el-form :model="formData" :rules="rules" ref="formData" label-width="130px" class="form-data">
        <el-form-item label="客户名称" prop="customerName">
          <el-input v-model="formData.customerName" disabled></el-input>
        </el-form-item>
        <el-form-item label="合同编号" prop="contractNo">
          <el-input v-model="formData.contractNo" disabled></el-input>
        </el-form-item>
        <el-form-item label="计划回款金额" prop="planAmount">
          <el-input v-model="formData.planAmount" placeholder="请输入计划回款金额" maxLength="15" clearable></el-input>
        </el-form-item>
        <el-form-item label="计划回款日期" prop="planDate">
          <el-date-picker v-model="formData.planDate" clearable type="date" value-format="yyyy-MM-dd" placeholder="请选择计划回款日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="提前几日提醒" prop="remindDay">
          <el-input v-model="formData.remindDay" placeholder="请输入天数" maxLength="10" clearable></el-input>
        </el-form-item>
        <el-form-item label="回款期数" prop="collectionPeriod">
          <el-input v-model="formData.collectionPeriod" placeholder="请输入回款期数" maxLength="10" clearable></el-input>
        </el-form-item>
        <el-form-item label="回款方式" prop="collectionModeId">
          <el-select class="type" v-model="formData.collectionModeId" clearable placeholder="请选择回款方式">
            <el-option v-for="item in receiptTypeOptions" :key="item.id" :label="item.description" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark" class="full-width">
          <el-input v-model="formData.remark" rows="2" type="textarea" placeholder="请输入备注" maxLength="500" clearable></el-input>
        </el-form-item>
        <el-form-item class="full-width btn-wrap">
          <el-button type="primary" @click="savePlan">保存</el-button>
          <el-button @click="closeDialog">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <view-detail ref="viewDetailRef" :items="detailItems"></view-detail>
  </div>
</template>
<script>
import { ContractApis, DictionaryApis } from "@/apis";
import NewTable from "@/components/new-table";
import ViewDetail from "@/views/components/view-detail";
import { CommonService } from "@/service/common";
import { DictionaryKey } from "@/utils/enum";
import dayjs from "dayjs";
export default {
  name: "detail-receipt-plan",
  props: { contract: Object },
  data() {
    return {
      visible: false,
      tableData: [],
      columns: [
        { label: "期数", prop: "collectionPeriod" },
        { label: "客户名称", prop: "customerName" },
        { label: "合同编号", prop: "contractNo" },
        { label: "计划回款金额", prop: "planAmount" },
        { label: "计划回款日期", prop: "planDate" },
        { label: "计划回款方式", prop: "collectionModeName" },
        { label: "提前几日提醒", prop: "remindDay" },
        {
          label: "操作",
          width: "120",
          render: (h, { row }) => {
            return (
              <span>
                <el-button type="text" onClick={() => this.$refs.viewDetailRef.show(row)}>
                  查看
                </el-button>
                <auth-button code="HTJHBJ" type="text" onClick={() => this.editPlan(row)}>
                  编辑
                </auth-button>
                <auth-button code="HTJHSC" type="text" onClick={() => this.delePlan(row)}>
                  删除
                </auth-button>
              </span>
            );
          },
        },
      ],
      pages: {
        props: {
          pageSize: 20,
          currentPage: 1,
          total: 0,
        },
        on: {
          currentChange: this.pageChange,
          sizeChange: this.sizeChange,
        },
      },
      formData: {
        id: "",
        customerId: "",
        customerName: "",
        contractId: "",
        contractNo: "",
        planAmount: "",
        planDate: "",
        remindDay: "",
        collectionPeriod: "",
        collectionModeId: "",
        collectionModeName: "",
        remark: "",
      },
      rules: {
        planAmount: [
          {
            required: true,
            trigger: "change",
            validator: (rule, value, callback) => {
              CommonService.validatorAmount(value, callback, "请输入正确的回款金额");
            },
          },
        ],
        planDate: [{ required: true, message: "请选择计划回款日期", trigger: "change" }],
        remindDay: [
          {
            trigger: "change",
            validator: (rule, value, callback) => {
              if (value === "") return callback();
              const days = dayjs(this.formData.planDate).diff(dayjs(new Date()), "day");
              if (value > days + 1) callback(new Error("提醒天数应小于计划回款日期与当前日期之差"));
              CommonService.validatorInteger(value, callback, "请输入正确的天数");
            },
          },
        ],
        collectionPeriod: [{ required: true, trigger: "change", message: "请输入回款期数" }],
      },
      receiptTypeOptions: [],
      detailItems: [],
    };
  },
  created() {
    this.getPlanList();
    this.initDetailItems();
  },
  methods: {
    initDetailItems() {
      const items = [...this.columns, { label: "备注", type: "fullWidth", prop: "remark" }];
      items.splice(-2, 1); // 删除操作
      this.detailItems = items;
    },
    // 回款计划
    getPlanList() {
      const { currentPage, pageSize } = this.pages.props;
      ContractApis.getReceiptPlans(this.contract.id, currentPage, pageSize).then((res) => {
        res.data.forEach((i) => {
          i.planDate = i.planDate && i.planDate.slice(0, 11);
        });
        this.tableData = res.data;
        this.pages.props.total = res.dataCount;
      });
    },
    newReceiptPlan() {
      this.initData();
      this.visible = true;
      DictionaryApis.getDictValueByKey(DictionaryKey.ReceiptType).then((res) => {
        this.receiptTypeOptions = res;
      });
    },
    editPlan(row) {
      for (const key in this.formData) {
        this.formData[key] = row[key] || "";
      }
      this.newReceiptPlan();
    },
    initData() {
      this.formData.customerId = this.contract.customerId;
      this.formData.customerName = this.contract.customerName;
      this.formData.contractId = this.contract.id;
      this.formData.contractNo = this.contract.contractNo;
    },
    delePlan(row) {
      this.$confirm("确定要删除该回款计划吗？", "注意", {
        type: "warning",
      }).then((res) => {
        ContractApis.deleReceiptPlan(row.id).then((res) => {
          if (res) {
            const index = this.tableData.findIndex((i) => i.id === row.id);
            this.tableData.splice(index, 1);
            this.$message.success("删除成功！");
          }
        });
      });
    },
    pageChange(p) {
      this.pages.props.currentPage = p;
      this.getPlanList();
    },
    sizeChange(size) {
      this.pages.props.pageSize = size;
      this.pages.props.currentPage = 1;
      this.pageChange();
    },
    async savePlan() {
      await this.$refs.formData.validate();
      if (this.formData.collectionModeId) {
        const collection = this.receiptTypeOptions.find((i) => i.id === this.formData.collectionModeId);
        this.formData.collectionModeName = collection ? collection.description : "";
      }
      const param = Object.assign({}, this.formData);
      param.remindDay = Number(param.remindDay);

      if (param.id) {
        await ContractApis.editReceiptPlan(param);
        const row = this.tableData.find((i) => i.id === param.id);
        Object.assign(row, param);
      } else {
        await ContractApis.addReceiptPlan(param);
        this.pageChange(1);
      }
      this.$message.success("保存成功!");
      this.visible = false;
    },
    closeDialog() {
      this.$refs.formData.resetFields();
      for (const key in this.formData) {
        this.formData[key] = "";
      }
      this.visible = false;
    },
    viewDetail(row) {},
  },
  components: { NewTable, ViewDetail },
};
</script>
